import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/Index'
import CoreBusiness from './views/CoreBusiness'
import Services from './views/Services'
import WhyUs from './views/WhyUs'
import Capabilities from './views/Capabilities'
import HSE from './views/HSE'
import ContactUs from './views/ContactUs'
import Projects from './views/Projects'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH,
  scrollBehavior (to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: 'SPSC'
      }
    },
    {
      path: '/coreBusiness',
      name: 'coreBusiness',
      component: CoreBusiness,
      meta: {
        title: 'Core Business'
      }
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      meta: {
        title: 'Service&Projects'
      }
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      meta: {
        title: 'Projects'
      }
    },
    {
      path: '/whyUs',
      name: 'whyUs',
      component: WhyUs,
      meta: {
        title: 'Why Us'
      }
    },
    {
      path: '/capabilities',
      name: 'capabilities',
      component: Capabilities,
      meta: {
        title: 'Capabilities'
      }
    },
    {
      path: '/hse',
      name: 'hse',
      component: HSE,
      meta: {
        title: 'HSE'
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs,
      meta: {
        title: 'ContactUs'
      }
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import(/* webpackChunkName: "about" */ './views/demo.vue'),
      meta: {
        keepAlive: true // 该字段表示该路由需要缓存
      }
    }
  ]
})
// 这是钩子进入页面之前,就修改title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title // 这 to.meta.title 是在router里设置的
  window.scrollTo(0, 0)
  next()
})

export default router
